import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import { TranslationService } from 'src/app/service/translation.service';
import { TranslateModule } from '@ngx-translate/core';
import { KeyValuePipe } from '@angular/common';
import { LoadingErrorComponent } from 'src/app/components/loading-error/loading-error.component';

@Component({
    selector: 'app-commons-modal-part',
    templateUrl: './commons-modal-part.html',
    styleUrls: ['./commons-modal-part.scss'],
    providers: [TranslationService],
    imports: [TranslateModule, KeyValuePipe, LoadingErrorComponent],
    standalone: true
})
export class CommonsModalPartComponent {

  public readonly translationService = inject(TranslationService);

  constructor() {
   
  }

  @Input() mapObject?:Map<any,any>

  @Output() dpactif:EventEmitter<boolean>=new EventEmitter<boolean>()
  @Output() probesDetailsTitle:EventEmitter<string>=new EventEmitter<string>()

  @Input() listContent?:boolean


  formatValue(value:string){
    let splitted = value.split(";", value.length);
    if(splitted.length>1){
      return 'list'
    }
    else return value
  }

  @Input() listObject?:string[]

  getListe(value:string){
    this.listObject= value.split(';',value.length)
  }

  actif(key:string){
    this.probesDetailsTitle.emit(this.formatProbeDetectName(key))
    this.dpactif.emit(true)
  }

  formatProbeDetectName(key: string) {
      let format= key.replace(/android/gi,"").replace(/ios/gi,'').replace(/_/gi,' ')
      if(format.startsWith(' ')){
          return format.charAt(1).toUpperCase() + format.slice(2)
      }else{return format.charAt(0).toUpperCase() + format.slice(1)}
  }
}
